import { Button, IconButton } from "@mui/material";
import React from "react";
const yaml = require("js-yaml");
import hljs from "highlight.js";
import "highlight.js/styles/monokai-sublime.css";
import { CopyAll } from "@mui/icons-material";

export const BlueTab = ({ sigmaURL }) => {
  const [content, setContent] = React.useState("");
  const readFile = async (url) => {
    await fetch(url)
      .then((resp) => resp.text())
      .then((data) => {
        try {
          setContent(data);
          data = yaml.safeLoad(data);
          console.log(data);
        } catch {
          console.error("Some error reading Sigma");
        }
      });
  };

  const convert = async () => {
    const url = "https://sigconverter.io/sigma";

    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        format: null,
        pipeline: [],
        rule: btoa(content),
        target: "opensearch",
      }),
    });
    console.log(resp.text());
  };

  const copyContent = () => {
    navigator.clipboard.writeText(content);
  };

  React.useEffect(() => {
    if (!sigmaURL) return;
    readFile(sigmaURL);
  }, [sigmaURL]);

  React.useEffect(() => {
    hljs.highlightAll();
  }, [content]);

  return (
    <>
      {!!sigmaURL && (
        <>
          <div className="command-title" style={{alignItems:"center"}}>
            Rule
            <a
              href={sigmaURL}
              rel="noopener noreferrer"
              target="_blank"
              className="mitre-link"
            >
              Rule Link
            </a>
            <a
              href="https://sigconverter.io/"
              rel="noopener noreferrer"
              target="_blank"
              className="mitre-link"
            >
              Converter
            </a>
            <IconButton onClick={copyContent}>
              <CopyAll />
            </IconButton>
          </div>
          {/* <Button onClick={convert}>Click me</Button> */}
          <pre className="language-yml">
            <div style={{ overflowX: "scroll" }}>
              <code dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          </pre>
        </>
      )}
      {!sigmaURL && <div>No playbooks, you can add to the repository</div>}
    </>
  );
};
